import { useState } from 'react'
import { PDPProductSizeGuide } from './SizeGuide.types'

const useSizeGuide = ({ pdpProductSizeGuides }: { pdpProductSizeGuides: PDPProductSizeGuide[] }) => {
  const [activePdpProductSizeGuide, setActivePdpProductSizeGuide] = useState(pdpProductSizeGuides[0].tabName)
  const [activeSizeGuideUnitIndex, setActiveSizeGuideUnitIndex] = useState(0)

  const handlePdpProductSizeGuideChange = (tabName: string) => {
    setActivePdpProductSizeGuide(tabName)
  }

  const handleUnitsChange = () => {
    setActiveSizeGuideUnitIndex(activeSizeGuideUnitIndex === 0 ? 1 : 0)
  }

  return {
    activeSizeGuideUnitIndex,
    handleUnitsChange,
    activePdpProductSizeGuide,
    handlePdpProductSizeGuideChange,
  }
}

export { useSizeGuide }
